// src/web.ts
var COLOR_CATEGORY_DEUTSCHLAND_WELT = "#31B3B3";
var COLOR_CATEGORY_KULTUR = "#76D016";
var COLOR_CATEGORY_NETZWELT = "#E20D67";
var COLOR_CATEGORY_REGIONEN = "#0B9FD8";
var COLOR_CATEGORY_SPORT = "#F6B827";
var COLOR_CATEGORY_WIRTSCHAFT = "#2BB971";
var COLOR_CATEGORY_WISSEN = "#FF9000";
var COLOR_CATEGORY_ALL = [
  COLOR_CATEGORY_DEUTSCHLAND_WELT,
  COLOR_CATEGORY_KULTUR,
  COLOR_CATEGORY_NETZWELT,
  COLOR_CATEGORY_REGIONEN,
  COLOR_CATEGORY_SPORT,
  COLOR_CATEGORY_WIRTSCHAFT,
  COLOR_CATEGORY_WISSEN
];
var COLOR_CATEGORY_BY_CATEGORY_ID = {
  "deutschland-welt": COLOR_CATEGORY_DEUTSCHLAND_WELT,
  bayern: COLOR_CATEGORY_REGIONEN,
  netzwelt: COLOR_CATEGORY_NETZWELT,
  sport: COLOR_CATEGORY_SPORT,
  wirtschaft: COLOR_CATEGORY_WIRTSCHAFT,
  kultur: COLOR_CATEGORY_KULTUR,
  wissen: COLOR_CATEGORY_WISSEN
};

export {
  COLOR_CATEGORY_DEUTSCHLAND_WELT,
  COLOR_CATEGORY_KULTUR,
  COLOR_CATEGORY_NETZWELT,
  COLOR_CATEGORY_REGIONEN,
  COLOR_CATEGORY_SPORT,
  COLOR_CATEGORY_WIRTSCHAFT,
  COLOR_CATEGORY_WISSEN,
  COLOR_CATEGORY_ALL,
  COLOR_CATEGORY_BY_CATEGORY_ID
};
//# sourceMappingURL=chunk-25BFSH2W.js.map